import styled from "styled-components";
import i18next from "i18next";
import { useEffect, useState } from "react";

const Container = styled.div`
  display: flex;
`;
const SwitchOff = styled.button`
  background: transparent !important;
  color: grey !important;
  border: none;
  padding: 0 0.5em;
`;
const SwitchOn = styled.button`
  color: #f2a900;
  background: transparent;
  border: none;
  padding: 0 0.5em;
`;

const Switcher = () => {
  const langList = ["id", "en"];
  const [language, setLanguage] = useState();

  useEffect(() => {
    if (!language) {
      setLanguage(localStorage.getItem("lang"));
    }
  }, [language]);

  const changeLanguage = (lang) => {
    i18next.changeLanguage(lang);
    localStorage.setItem("lang", lang);
    setLanguage(lang);
  };

  return (
    <Container>
      {langList.map((lang, i) => {
        return lang === language ? (
          <SwitchOn
            type="button"
            className="btn btn-outline-primary"
            onClick={() => changeLanguage(lang)}
            key={i}
          >
            {lang.toUpperCase()}
          </SwitchOn>
        ) : (
          <SwitchOff
            type="button"
            className="btn btn-outline-primary"
            onClick={() => changeLanguage(lang)}
            key={i}
          >
            {lang.toUpperCase()}
          </SwitchOff>
        );
      })}
    </Container>
  );
};

export default Switcher;
